module.exports = __webpack_public_path__ + "static/media/Misdreavus_gaussian2.0bc3e989.png";